<!-- ログイン認証後の処理 -->
<template>
  <div>
    <FirstLoginModal v-if="serviceId" ref="firstLoginModal" @submit="submit" />
  </div>
</template>

<script>
import { createSetCookie, parseCookie } from "@/utils/cookie";

export default {
  data() {
    return {
      loading: true,
      verifier: undefined,
      challenge: undefined,
      backUri: undefined,
      accountList: [],
      idToken: undefined,
      subscriptions: [],
      serviceId: false
    };
  },
  created() {
    this.getBackUri();
  },
  mounted () {
    this.getUserInfo();
  },
  beforeDestroy() {},
  methods: {
    getBackUri() {
      const cookie = parseCookie(document.cookie);
      console.log("created cookie", cookie);
      this.backUri = this.$route.query.authorization_back_uri
        ? this.$route.query.authorization_back_uri
        : cookie.back_uri;
      console.log("created backUri", this.backUri);
    },
    /**
     * ユーザー情報の取得
     */
    getUserInfo() {
      this.$loading.show()
      this.$repositories("user")
        .contractInfo()
        .then((resLogin) => {
          const contractInfo = resLogin.data.contractInfo;
          // const contractInfoLen = contractInfo.length;
          // customerNoの数で処理を変更
          // if (contractInfoLen > 1) {
          //   for (let i = 0; i < contractInfoLen; i++) {
          //     this.accountList.push({
          //       id: contractInfo[i].customerNo,
          //       name: contractInfo[i].companyName
          //     });
          //   }
          //   this.$refs.accountModal.show();
          // } else {
          this.userConfirm(contractInfo[0].customerNo);
          this.subscriptions = contractInfo[0].subscriptions;
          this.boSrvCd = contractInfo[0].subscriptions[0].boServiceCode;
          // }
          this.$store.commit("userInfo/setUserSubscriptions", contractInfo);
        })
        .catch((err) => {
          console.log("BFF:loginエラー", err);
          this.$store.commit("loginInfo/setLoginState", false);
          this.errorLogin();
        })
        .finally(() => {
          this.$loading.hide()
        });
    },
    // ログイン関係でエラーが発生した場合の共通処理
    errorLogin() {
      // 戻り先用のクッキー削除
      this.$loading.hide()
      document.cookie = createSetCookie("back_uri", "", new Date(0));
      this.$store.commit("loginInfo/setLoginState", false);
      this.logout();
    },

    async userConfirm(customerNo) {
      this.$loading.show()
      const params = new FormData();
      params.append("customerNo", customerNo);
      /*
      const params = {
        customerNo: customerNo
      };
      */

      const updateUserResult = await this.$repositories("user").updateUser(
        params
      );
      if (updateUserResult.isError) {
        console.log("BFF:ユーザー情報更新エラー", updateUserResult);
        this.$store.commit("loginInfo/setLoginState", false);
        this.errorLogin();
        return;
      }

      // ユーザー情報取得
      const postUserResult = await this.$repositories("user").postUser();
      if (postUserResult.isError) {
        console.log("/v1/users/my: エラー", postUserResult);
        this.$store.commit("loginInfo/setLoginState", false);
        this.errorLogin();
        return;
      }
      this.$store.commit(
        "loginInfo/setContentsServiceId",
        postUserResult.data.contentsServiceId
      );
      this.$store.commit("userInfo/setUserInfo", postUserResult.data);
      this.$store.commit('auth/set', { user: postUserResult.data });

      // 無料会員(190)の場合
      if (postUserResult.data.contentsServiceId == 190) {
        this.serviceId = true;
        // 利用規約同意画面チェック
        await this.$repositories("auth")
          .getAgreeCheck()
          .then((modalFlag) => {
            if (modalFlag.data.consentStatusFlg) {
              this.$refs.firstLoginModal.show();
            } else {
              this.finishLogin();
            }
            console.log(modalFlag.data);
          })
          .catch((err) => {
            console.log("BFF:利用規約同意チェックエラー", err);
            this.errorLogin();
          })
          .finally(() => {
            console.log("認証OK");
            this.$loading.hide()
          });
      } else {
        this.finishLogin();
      }
    },

    submit (flg) {
      if (flg) {
        this.finishLogin();
      }
    },

    // ログインが完了した場合の共通処理
    async finishLogin() {
      // 戻り先用のクッキー削除
      document.cookie = createSetCookie("back_uri", "", new Date(0));
      // this.$auth.init("", "", data, this.subscriptions);
      // this.$auth.init(data, this.subscriptions);
      this.$store.commit("loginInfo/setLoginState", true);

      const backUri = this.backUri ? this.backUri : "/";
      console.log("finishLogin backUri", backUri);
      const redirect = this.$route.query.redirectURI;
      if (redirect != null) {
        console.log("SSOリダイレクト");
        location.href = redirect;
      } else {
        if (backUri.includes("mypage")) {
          window.open(`${process.env.VUE_APP_MYPAGE_DOMAIN}` + backUri, "_self");
        } else if (backUri.includes("favorite")) {//お気に入りの場合
          window.open(`${process.env.VUE_APP_TOP_DOMAIN}` + backUri,"_self");
        }  else {
          window.open(`${process.env.VUE_APP_BASE_URL}` + backUri, "_self");
        }
      }
      this.$loading.hide()
    }
  }
};
</script>